// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"485c4167","252":"2a69e2e5","619":"718ae2f6","871":"34c3e827","928":"4bdc13b3","952":"6d599f5e"}[chunkId] + ".chunk.js";
};